import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    title: String,
    url: String
  }

  connect() {
    if (this.hasButtonTarget && this.supported) {
      this.buttonTarget.classList.remove("hidden")
    }
  }

  async share() {
    if (!this.supported) return

    try {
      await navigator.share(this.shareData)
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }

  get supported() {
    return navigator.share && (!navigator.canShare || navigator.canShare(this.shareData))
  }

  get shareData() {
    return {
      title: this.titleValue,
      url: this.urlValue
    }
  }
}
